import Swal from 'sweetalert2';

let Qlist = JSON.parse(localStorage.getItem("Qlist"));

export const ADD_TO_CART = async (e, product_id, qty) => {
    e.preventDefault();
    
    if (qty == 0) {
        
        Swal.fire({
            title: 'Error!',
            text: 'Please, Insert Valid Qty',
            icon: 'error',
            showConfirmButton: false,
            timer: 1200
        })
        return false;
        
    }
    
    var data = {
        product_id: product_id,
        qty : parseInt(qty)
    }

    if (Qlist.length == 0) {
        Qlist.push(data)
    } else {
        let res = Qlist.find(element => element.product_id == product_id);

        if (res === undefined) {
            Qlist.push(data)
        } else {
            UPDATE_CART(e, product_id, qty)
        }
    }


    localStorage.setItem("Qlist", JSON.stringify(Qlist));

    Swal.fire({
        title: 'Success!',
        text: 'Product Added to Quote List',
        icon: 'success',
        showConfirmButton: false,
        timer: 1300
    })

    return true;
}

export const UPDATE_CART = async (e, product_id, qty, isCart) => {
    for (let product of Qlist) {
        if (product.product_id == product_id) {

            if (isCart) {
                product.qty = parseInt(qty);
            } else {
                product.qty = parseInt(product.qty) + parseInt(qty);
            }

        }
    }

    localStorage.setItem("Qlist", JSON.stringify(Qlist));
}

export const REMOVE_ITEM_CART = async (product_id) => {
    let temp = Qlist.filter(item => item.product_id != product_id);
    localStorage.setItem("Qlist", JSON.stringify(temp));
}

export const REMOVE_CART = async () => {
    localStorage.setItem("Qlist", "[]");
}

export const GET_CART = async () => {
    let data =  JSON.parse(localStorage.getItem("Qlist"));

    return data;
}

export const COUNT_CART = async () => {
    return Qlist ? Qlist.length : 0;
}